import { Model } from '@vuex-orm/core'

export default class Careerpage extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'careerpages'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      slug: this.attr(null),
      title: this.attr(null),
      default: this.attr(null),
      sections: this.attr(null),
      builder_url: this.attr(null),
      career_url: this.attr(null),
      created_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Careerpage.js